import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import WhyChooseUs from "@/components/WhyChooseUs";
import ReviewWidget from "@/components/ReviewWidget";
import ServiceAreas from "@/components/ServiceAreas";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { faqs } from "@/lib/faq-data";

const Index = () => {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="4 Seasons Painting | Interior & Exterior Painters in Phoenix, AZ"
        description="Phoenix painting contractor serving the whole Valley. Interior & exterior painting, power washing, sun screens, rain gutters & pergolas. Free estimates, open 24/7."
        path="/"
        jsonLd={faqJsonLd}
      />
      <TopBar />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <WhyChooseUs />
        <ReviewWidget />
        <ServiceAreas />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
